/* <product-gallery>: swipeable media track with thumbnails, dots and counter. */
if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.counter = this.querySelector('[data-gallery-current]');
      if (!this.track || this.slides.length < 2) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.galleryThumb)));
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.goTo(this.current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.current - 1); }
      });

      this.current = 0;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            this.setActive(Number(entry.target.dataset.index));
          }
        });
      }, { root: this.track, threshold: [0.6] });
      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: 'smooth' });
      this.setActive(target);
    }

    setActive(index) {
      if (index === this.current && this.counter?.textContent === String(index + 1)) return;
      // Pause a video that scrolls out of view.
      this.slides[this.current]?.querySelector('video')?.pause();
      this.current = index;
      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (this.counter) this.counter.textContent = index + 1;
    }
  }
  customElements.define('product-gallery', ProductGallery);
}
